const SIDEBAR_KEY = "ui.sidebarCollapsed";
const THEME_KEY = "ui.theme";

function emit(name, detail) {
  window.dispatchEvent(new CustomEvent(name, { detail }));
}

export function bootstrapUI() {
  const collapsed = localStorage.getItem(SIDEBAR_KEY) === "1";
  document.body.classList.toggle("sidebar-collapsed", collapsed);

  let theme = localStorage.getItem(THEME_KEY);
  if (theme !== "dark" && theme !== "light") {
    const prefersDark =
      window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
    theme = prefersDark ? "dark" : "light";
  }
  document.documentElement.classList.toggle("theme-dark", theme === "dark");

  emit("ui:sidebar", { collapsed });
  emit("ui:theme", { theme });

  return { collapsed, theme };
}

export function toggleSidebar() {
  const next = !document.body.classList.contains("sidebar-collapsed");
  document.body.classList.toggle("sidebar-collapsed", next);
  document.body.classList.add("sidebar-animating");
  localStorage.setItem(SIDEBAR_KEY, next ? "1" : "0");
  emit("ui:sidebar", { collapsed: next });

  setTimeout(() => {
    document.body.classList.remove("sidebar-animating");
  }, 300);

  return next;
}

export function toggleTheme() {
  const isDark = document.documentElement.classList.contains("theme-dark");
  const next = isDark ? "light" : "dark";
  document.documentElement.classList.toggle("theme-dark", next === "dark");
  localStorage.setItem(THEME_KEY, next);
  emit("ui:theme", { theme: next });
  return next;
}
